import api from '@pray/shared/utils/api';

import type { SeedResponse, SeedSourceValue } from './types';

const SEEDS_URL = '/web/studio/admin/seed-emails/seeds';

export type PostCreateSeedParams = {
  email: string;
  source?: SeedSourceValue;
  groupIds?: string[];
};

/**
 * Creates one seed and answers 201 with it. An address deleted earlier comes back restored, so the
 * caller never has to ask whether it existed before.
 */
export async function postCreateSeed({ email, source = 'other', groupIds = [] }: PostCreateSeedParams) {
  const res = await api.executePostRequest<{ data: SeedResponse }>(SEEDS_URL, {
    email,
    source,
    group_ids: groupIds,
  });
  return res.data.data;
}
